module.exports = __webpack_public_path__ + "img/jobs2.98431eb3.png";